// USER
export const ADD_USER = 'ADD_USER';